import { PressableIcon } from '@bonanza-social/moonlight';
import { ParamListBase } from '@bonanza-social/navigation';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

type BackButtonProps<T extends ParamListBase> = {
  navigation: NativeStackNavigationProp<T>;
};

function BackButton<T extends ParamListBase>({
  navigation,
}: BackButtonProps<T>) {
  return (
    <PressableIcon
      gradient="accentBackground"
      padding="space-100"
      name="arrowBack"
      iconWidth="space-600"
      iconHeight="space-600"
      onPress={navigation.goBack}
      testID="back-arrow-button"
    />
  );
}

export default BackButton;
